import styled from '@emotion/styled';

import { Card } from './card';

export const FormCard = styled(Card)`
  width: 100%;
  overflow: visible;
`;
